package top.wcpe.allincore.ui.runtime.event

/** 平台无关的逻辑坐标命中区域。 */
fun interface HitRegion {
    fun contains(x: Double, y: Double): Boolean
}

/** 可幂等注销单个 session 命中注册项的句柄。 */
fun interface HitRegistration {
    fun unregister()
}

/**
 * 当前 session 的扩展命中区域注册表。
 *
 * 无 owner 命中时返回 null，由调用方回退到普通 runtime 命中分发。
 */
class SessionHitRegistry<OWNER : Any> {
    private val entries = ArrayList<Entry<OWNER>>()
    private var nextOrder = 0L

    /** 注册 owner；z 越高越优先，同 z 时后注册者优先。 */
    fun register(owner: OWNER, zIndex: Int, region: HitRegion): HitRegistration {
        val entry = Entry(owner, zIndex, nextOrder++, region)
        entries.add(entry)
        return HitRegistration { entries.removeAll { it === entry } }
    }

    /** 返回指定逻辑坐标的独占 owner；null 表示交给普通 runtime。 */
    fun ownerAt(x: Double, y: Double): OWNER? = entries.asSequence()
        .filter { it.region.contains(x, y) }
        .maxWithOrNull(compareBy<Entry<OWNER>> { it.zIndex }.thenBy { it.order })
        ?.owner

    /** 清除当前 session 的全部命中项与注册顺序状态。 */
    fun clear() {
        entries.clear()
        nextOrder = 0L
    }

    fun size(): Int = entries.size

    private data class Entry<OWNER : Any>(val owner: OWNER, val zIndex: Int, val order: Long, val region: HitRegion)
}
